import styled from "styled-components";
import { Player } from "@remotion/player";

export const RemotionPlayer = styled(Player)`
  // this is targeting the video controls bar
  > div:nth-child(2) {
    z-index: 4;
    padding-top: 0 !important;
  }

  @media print {
    span {
      font-size: ${({ printFontSize }) => `${printFontSize}px`};
      border-radius: ${({ scaleFactor }) => `${30 * scaleFactor}px 0px 0px ${30 * scaleFactor}px`};
      padding: ${({ scaleFactor, showLandscape }) =>
        showLandscape
          ? `${20 * scaleFactor}px ${30 * scaleFactor}px`
          : `${25 * scaleFactor}px ${40 * scaleFactor}px`};
    }
  }
`;
